import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// import NotificationError from "../../../components/UI/NotificationError/NotificationError";
import ProfileDataItem from "./ProfileDataItem/ProfileDataItem";

import "./ProfileData.sass";

function ProfileData({ userData, userDataError }) {
  const [entity] = useState([
    {
      field: "profile_type",
      title: "Profile Type",
      data:
        userData && userData?.profile_type
          ? userData?.profile_type?.charAt(0).toUpperCase() +
            userData?.profile_type?.slice(1)
          : "Basic",
      isEditable: false,
    },
    {
      field: "fullName",
      title: "Full name",
      data: userData && `${userData.first_name} ${userData.last_name}`,
      isEditable: true,
    },
    {
      field: "email",
      title: "Email",
      data: userData && userData.email,
      isEditable: true,
    },
    {
      field: "phone",
      title: "Primary phone",
      data: userData && userData.phone,
      isEditable: true,
    },
    {
      field: "address",
      title: "Address",
      data: userData && userData.address,
      isEditable: true,
    },
  ]);

  if (userDataError !== "") {
    throw new Error(userDataError);
  }

  return (
    <>
      {userData && (
        <div className="col-12">
          <article className="row align-items-start profile-data">
            {userData && userData.cid && (
              <section className="col-12 col-md-6 col-lg-2 profile-data-cell profile-data-cell--cid">
                <p className="profile-data-cell__title">Customer ID</p>
                <p className="profile-data-cell__text">{userData.cid}</p>
              </section>
            )}
            {entity.map((item, index) => (
              <ProfileDataItem key={index} fieldItem={item} />
            ))}
          </article>
        </div>
      )}
    </>
  );
}

ProfileData.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
  userDataError: PropTypes.string,
};
ProfileData.defaultProps = {
  userData: null,
  userDataError: "",
};

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
  dataIsLoading: state.userDataStore.userDataIsLoading,
  userDataError: state.userDataStore.userDataError,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileData);
